import React from 'react';
import Icon from '../../assets/images/icons/cube.png';

const Cube = ({ ...props }) => (
  <img style={{ margin: 'auto' }} width="100%" src={Icon} {...props} alt="icon" />
);

export default Cube;
